import styles from "./EntrepreneurAccount.module.css";

import { useTranslation } from "react-i18next";

import Header from "../../components/Header/Header";
import Footer from "../../components/footer/Footer";

import rightArrow from "../../assets/SetaDireita.svg";

import { useParams } from "react-router-dom";
import EntrepreneurAccountData from "../../components/EntrepreneurAccountData";
import EntrepreneurAccountChat from "../EntrepreneurAccountChat/EntrepreneurAccountChat";
import EntrepreneurAccountOrders from "../../components/EntrepreneurAccountOrders";
import EntrepreneurAccountProducts from "../../components/EntrepreneurAccountProducts";
import EntrepreneurAddOrEditProduct from "../../components/EntrepreneurAddOrEditProduct";
import { useEffect, useState } from "react";
import SideBar from "../../components/SideBar/SideBar";
import EntrepreneurRelatorio from "../EntrepreneurRelatorio/EntrepreneurRelatorio";

const EntrepreneurAccount = () => {
  const { content, subContent } = useParams();
  const { t } = useTranslation();

  const activeSubContent =
    subContent && (subContent === "edit" || subContent === "add");

  const [isMobileMenuVisible, setIsMobileMenuVisible] = useState<boolean>(true);
  const [isSmallScreen, setIsSmallScreen] = useState<boolean>(
    window?.innerWidth < 768
  );

  const handleWindowSizeChange = () =>
    setIsSmallScreen(window?.innerWidth < 768);

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);

    return () => window.removeEventListener("resize", handleWindowSizeChange);
  }, []);

  return (
    <>
      <Header
        boxShadow
        mobileMenuActiveState={isMobileMenuVisible}
        toggleMobileMenu={setIsMobileMenuVisible}
        isSmallScreen={isSmallScreen}
        hamburgerIcon={true}
      />
      <main className={styles.mainContainer}>
        <section className={styles.sectionContainer}>
          {!activeSubContent ? (
            <div className={styles.breadCrumbs}>
              <span>{t("accountMenu.myAccount")}</span>
              <img src={rightArrow} />
              <span className={styles.optionSelected}>
                {t(`accountMenu.${content}`)}
              </span>
            </div>
          ) : (
            <div className={styles.breadCrumbs}>
              <span>{t("accountMenu.myAccount")}</span>
              <img src={rightArrow} />
              <span>{t(`accountMenu.${content}`)}</span>
              <img src={rightArrow} />
              <span className={styles.optionSelected}>
                {subContent === "add" && t(`accountMenu.addProduct`)}
                {subContent === "edit" && t(`accountMenu.editProduct`)}
              </span>
            </div>
          )}

          {/*Incluir renderização condicional de componentes separados que representam cada aba do menu do empreendedor*/}
          {content === "data" && <EntrepreneurAccountData />}
          {content === "logs" && <EntrepreneurRelatorio/>}
          {content === "orders" && <EntrepreneurAccountOrders />}
          {content === "chat" && <EntrepreneurAccountChat />}
          {content === "products" && subContent === "list" && (
            <EntrepreneurAccountProducts />
          )}
          {content === "products" &&
            (subContent === "edit" || subContent === "add") && (
              <EntrepreneurAddOrEditProduct
                action={subContent as "add" | "edit"}
              />
            )}
        </section>
        {(!isSmallScreen || (isSmallScreen && isMobileMenuVisible)) && (
          <aside className={styles.asideContainer}>
            <SideBar isSmallScreen={isSmallScreen} closeMobileMenu={() => setIsMobileMenuVisible(false)}/>
          </aside>
        )}
      </main>
      {!isSmallScreen && <Footer />}
    </>
  );
};

export default EntrepreneurAccount;
